import * as Rox from "rox-browser";

export const cobrowse = {
    enable_cobrowse: new Rox.Flag(),
};
